export const columns = [
  { prop: "typeName", label: "类型" },
  { prop: "name", label: "类型名称" },
  { prop: "operator", label: "编辑人" },
  { prop: "modifyTime", label: "编辑时间" },
  { prop: "operate", label: "操作" },
];
